import axios from "../../config/axiosConfig";
import { CREATE_CREDIT_NOTE_BILL_BASE_RETURN, GET_CREDIT_NOTE_BILL_BASE_RETURNS_PAGE, GET_CREDIT_NOTE_BILL_BASE_RETURNS, CREDIT_NOTE_BILL_BASE_RETURN_REQUEST, CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_SUCCESS, UPDATE_CREDIT_NOTE_BILL_BASE_RETURN, DELETE_CREDIT_NOTE_BILL_BASE_RETURN, CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE } from "../types";

export const getCreditNoteBillBaseReturnsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST });
      
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id,Debit_Account_Id,Item_Id'
      };
      return axios.get("/credit-note-bill-base-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_CREDIT_NOTE_BILL_BASE_RETURNS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};
export const getCreditNoteBillBaseReturns = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/credit-note-bill-base-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_CREDIT_NOTE_BILL_BASE_RETURNS, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getCreditNoteBillBaseReturnByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/credit-note-bill-base-return/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getCreditNoteBillBaseReturnById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST });

      return axios.get(`/credit-note-bill-base-return/get/${id}`).then((response) => {
        dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getValidatedIncrementedVchNoCreditNoteBillBaseReturn = (currentVchNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };

      const response = await axios.get("/credit-note-bill-base-return/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const createCreditNoteBillBaseReturn = (creditNoteBillBaseReturn) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST });
      const newCreditNoteBillBaseReturn = {
        ...creditNoteBillBaseReturn
      };
      return axios.post("/credit-note-bill-base-return/add", newCreditNoteBillBaseReturn,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_CREDIT_NOTE_BILL_BASE_RETURN, payload: response.data });
        } else {
          dispatch({
            type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE,
            error: "Credit Note create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateCreditNoteBillBaseReturn = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST });
      const { auth } = getState();
      return axios.put("/credit-note-bill-base-return/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_CREDIT_NOTE_BILL_BASE_RETURN,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE,
            error: "Credit Note update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteCreditNoteBillBaseReturn = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST });
      const { auth } = getState();
      return axios.delete(`/credit-note-bill-base-return/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_CREDIT_NOTE_BILL_BASE_RETURN, id: id });
          const include = ['id', 'Vch_No', 'Date', 'Account_Id', 'Debit_Account_Id', 'Invoice_No', 'Invoice_Date', 'Amount', 'Total_Amount', 'Item_Id'].join(',');
          const searchCols = ['Vch_No'].join(',');
          const { inventory: { creditNoteBillBaseReturn: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getCreditNoteBillBaseReturnsWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const sendMailCreditNoteBillBaseReturn = (mailData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', mailData.to);
      formData.append('templateId', mailData.templateId);
      formData.append('creditNoteId', mailData.creditNoteId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', mailData.recipientType || 'custom');
      formData.append('moduleName', mailData.moduleName);
      
      // Add PDF attachment if exists
      if (mailData.pdfAttachment) {
        formData.append('attachment', mailData.pdfAttachment, `credit_node_bill_base_return_${mailData.creditNoteId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/credit-note-bill-base-return/mail-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const sendWhatsappCreditNoteBillBaseReturn = (whatsappData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', whatsappData.to);
      formData.append('templateId', whatsappData.templateId);
      formData.append('creditNoteId', whatsappData.creditNoteId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', whatsappData.recipientType || 'custom');
      
      // Add PDF attachment if exists
      if (whatsappData.pdfAttachment) {
        formData.append('attachment', whatsappData.pdfAttachment, `credit_node_bill_base_return_${whatsappData.creditNoteId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/credit-note-bill-base-return/whatsapp-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};